<template>
	<div>
		<div class="info-list-block" v-for="(item, index) in list" :key="index">
			<div class="label">{{ item.label }}</div>
			<div class="value">{{ item.value }}</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'info-list',
	props: {
		list: {
			type: Array,
			default: () => []
		}
	}
}
</script>
<style lang="scss" scoped>
@import '~@nio-fe/nio-app-ui/es/style';
.info-list-block {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 15px;
	.label {
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 22px;
		color: #9b9da9;
	}
	.value {
		font-family: 'PingFang SC';
		font-style: normal;
		font-weight: 400;
		font-size: 16px;
		line-height: 22px;
		text-align: right;
		color: #040b29;
	}
}
</style>
